module.exports = __webpack_public_path__ + "media/images/vp/icon.profile.whatsup.red-b69d60e243c377b8808107122dac2177.svg";